import { DDDFreespinWinPresentation } from "../freespin/DDDFreespinWinPresentation";

export class DDDSuperFreespinWinPresentation extends DDDFreespinWinPresentation {
    constructor() {
        super(`DDDSuperFreespinWinPresentation`);
    }
}
